<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" href="javascript:void(0)">Related Assets</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <button
          class="m-1 mr-2"
          type="button"
          color="primary"
          mat-raised-button
          (click)="onManageAssets()"
          matTooltip="Click this button to sync assets.">
          <mat-icon>forklift</mat-icon>
          Manage Assets
        </button>

        <mat-menu #appMenu="matMenu">
          <button mat-menu-item (click)="dataSource.selectAllToggle()">
            <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
            {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
          </button>
          <button mat-menu-item (click)="onUnlinkSelected()" [disabled]="!dataSource.selection.hasValue()">
            <mat-icon>link_off</mat-icon> Unlink Selected
          </button>
        </mat-menu>

        <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Incident Assets." style="min-width: 120px">
          <mat-icon>more_vert</mat-icon>
          List Menu
        </button>
      </span>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search"
          id="search-input"
          matTooltip="Search for Assets."/>

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          id="search-button"
          matTooltip="Click this button to run the current search.">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>
    </div>
  </nav>

  <div class="mat-elevation-z8 scroll-box">
    <mat-paginator #paginator1 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

    <table mat-table [dataSource]="dataSource" matSort matSortActive="id" matSortDirection="asc" matSortDisableClear>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox
            (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
            matTooltip="Toggle select all records.">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let asset">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(asset.id) : null"
            [checked]="dataSource.selection.isSelected(asset.id)"
            matTooltip="Toggle select this record.">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Toggle sorting by the id of the asset.">
          ID #
        </th>
        <td mat-cell *matCellDef="let asset">
          {{ asset.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the name of the asset." [style.width.px]="280">
          Name
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
          {{ asset.name  }}
        </td>
      </ng-container>

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the code of the asset.">
          Code
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
          {{ asset.code  }}
        </td>
      </ng-container>

      <ng-container matColumnDef="asset_type">
        <th mat-header-cell *matHeaderCellDef class="no-padding" [style.width.px]="280">
          Type
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
          <ng-container *ngIf="asset.asset_type?.parent">
            <small style="display: block;">
              {{ (asset.asset_type?.parent?.name | ellipsis: ['30']) || '' }}
            </small>
          </ng-container>
          <mat-icon *ngIf="asset.asset_type?.parent_id" style="font-size: 16px;">subdirectory_arrow_right</mat-icon>
          {{ (asset.asset_type?.name | ellipsis: ['30'])  || '' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="flags">
        <th mat-header-cell *matHeaderCellDef class="no-padding" [style.width.px]="100">
          <div class="d-flex align-items-center">
            <span>Flags</span>
            <button
              type="button"
              mat-icon-button
              class="header-info-help-button"
              aria-label="Explain Asset flags"
              matTooltip="What do these flags mean?"
              (click)="onOpenFlagsLegend()">
              <mat-icon>help_outline</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
          <mat-icon *ngIf="asset.is_visible" matTooltip="Visible on Mobile app." class="visible-yes">visibility</mat-icon>
          <mat-icon *ngIf="asset.is_mobile" matTooltip="Movable Asset." class="mobile-yes">directions_car</mat-icon>
          <mat-icon *ngIf="asset.is_safety_critical" matTooltip="Safety Critical." class="safety-critical-yes">warning</mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="no-padding">
          Status
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
        <span [style.color]="assetsService.getStatusColor(asset.status) || null">
          {{ assetsService.getStatusLabel(asset.status) }}
        </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="owner_type">
        <th mat-header-cell *matHeaderCellDef class="no-padding">
          Owner Type
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
          {{ assetsService.getOwnerTypeLabel(asset.owner_type) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="condition_rating">
        <th mat-header-cell *matHeaderCellDef class="no-padding">
          Condition Rating
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
        <span [style.color]="assetsService.getConditionColor(asset.condition_rating) || null">
          {{ assetsService.getConditionLabel(asset.condition_rating)  }}
        </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="160"></th>
        <td mat-cell *matCellDef="let asset">
          <button type="button" mat-button (click)="onUnlinkAsset(asset.id)">
            Unlink
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
    </table>

    <mat-paginator #paginator2 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>
